import React, { useState, useRef, useEffect } from 'react'
import classNames from 'classnames'
import './CommentInput.scss'

const CommentInput = ({ placeholder = 'Add a comment...', onChange, id = 'commentInput', value, hasShadow, noBorder }) => {
  const [inputValue, setInputValue] = useState(value || '')
  const [showLabel, toggleLabel] = useState(value ? false : true)
  const textareaRef = useRef(null)

  useEffect(() => {
    autoResize()
  }, [inputValue])

  useEffect(() => {
    setInputValue(value)
    toggleLabel(value ? false : true)
  }, [value])

  const onFieldFocus = () => {
    toggleLabel(false)
  }

  const onFieldBlur = () => {
    if (inputValue) {
      toggleLabel(false)
    } else {
      toggleLabel(true)
    }
  }

  const autoResize = () => {
    const textarea = textareaRef.current
    if (textarea) {
      textarea.style.height = 'auto'
      textarea.style.height = `${textarea.scrollHeight}px`
    }
  }

  const onFieldChange = (e) => {
    const getValue = e.target.value
    setInputValue(getValue)
    onChange && onChange(getValue)
    autoResize()
  }

  return (
    <div
      className={classNames(
        'viso-comment-input',
        hasShadow && 'viso-comment-input--shadow',
        noBorder && 'viso-comment-input--no-border'
      )}
      onClick={() => textareaRef.current.focus()}
    >
      {showLabel &&
        <label
          htmlFor={id}
          className={classNames(
            'viso-comment-input__label',
            hasShadow && 'viso-comment-input__label--shadow',
            noBorder && 'viso-comment-input__label--no-border'
          )}
        >
          {placeholder}
        </label>
      }
      <textarea
        className={classNames(
          'viso-comment-input__field',
          hasShadow && 'viso-comment-input__field--shadow',
          noBorder && 'viso-comment-input__field--no-border'
        )}
        ref={textareaRef}
        onChange={onFieldChange}
        name={id}
        id={id}
        value={inputValue}
        onFocus={onFieldFocus}
        onBlur={onFieldBlur}
        rows={1}
      />
    </div>
  )
}

export default CommentInput